import { Icon } from '@chakra-ui/react';

export default function AddCircleIcon(props) {
  return (
    <Icon
      width='24px'
      height='25px'
      viewBox='0 0 24 25'
      xmlns='http://www.w3.org/2000/svg'
      fill='currentColor'
      {...props}
    >
      <path d='M12 24.4922C5.47266 24.4922 0.046875 19.0664 0.046875 12.5391C0.046875 6 5.46094 0.585938 11.9883 0.585938C18.5273 0.585938 23.9531 6 23.9531 12.5391C23.9531 19.0664 18.5391 24.4922 12 24.4922ZM12 22.5C17.5312 22.5 21.9609 18.0703 21.9609 12.5391C21.9609 7.00781 17.5195 2.57812 11.9883 2.57812C6.45703 2.57812 2.05078 7.00781 2.05078 12.5391C2.05078 18.0703 6.46875 22.5 12 22.5ZM6.5625 12.5391C6.5625 11.9531 6.96094 11.543 7.55859 11.543H11.0039V8.09766C11.0039 7.5 11.4023 7.08984 11.9766 7.08984C12.5625 7.08984 12.9727 7.5 12.9727 8.09766V11.543H16.4297C17.0156 11.543 17.4258 11.9531 17.4258 12.5391C17.4258 13.1133 17.0156 13.5 16.4297 13.5H12.9727V16.957C12.9727 17.5547 12.5625 17.9531 11.9766 17.9531C11.4023 17.9531 11.0039 17.543 11.0039 16.957V13.5H7.55859C6.96094 13.5 6.5625 13.1133 6.5625 12.5391Z' />
    </Icon>
  );
}
